"use client";

import { useState } from "react";
import { TelecallingTopBar } from "@/components/demos/telecalling/TelecallingTopBar";
import { TelecallingHero } from "@/components/demos/telecalling/TelecallingHero";
import { TelecallingServicesSection } from "@/components/demos/telecalling/TelecallingServicesSection";
import { TelecallingTrustSection } from "@/components/demos/telecalling/TelecallingTrustSection";
import { CampaignProposalModal } from "@/components/demos/telecalling/CampaignProposalModal";
import { TELECALLING_CAMPAIGNS, calculateIndicativeRetainer } from "@/lib/demos/telecallingData";

export default function TelecallingPortalPage() {
  const [currency, setCurrency] = useState<"INR" | "USD">("INR");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalInitialData, setModalInitialData] = useState<{
    campaignId: string;
    seatsCount: number;
    shiftType: "day" | "night" | "247";
    monthlyRetainer: number;
  } | undefined>(undefined);
  const [isResetting, setIsResetting] = useState(false);

  async function handleResetDemo() {
    setIsResetting(true);
    try {
      await fetch("/api/demos/telecalling/reset", { method: "POST" });
    } catch (err) {
      console.error("[Reset Demo Error]", err);
    } finally {
      setIsResetting(false);
    }
  }

  function handleOpenProposalFromHero(data: {
    campaignId: string;
    seatsCount: number;
    shiftType: "day" | "night" | "247";
    monthlyRetainer: number;
  }) {
    setModalInitialData(data);
    setIsModalOpen(true);
  }

  function handleSelectCampaign(campaignId: string) {
    const calc = calculateIndicativeRetainer(campaignId, 6, "day", currency);
    setModalInitialData({
      campaignId,
      seatsCount: 6,
      shiftType: "day",
      monthlyRetainer: calc.monthlyTotal,
    });
    setIsModalOpen(true);
  }

  return (
    <main className="min-h-screen flex flex-col bg-slate-950">
      {/* Top Header Bar */}
      <TelecallingTopBar
        currency={currency}
        onCurrencyToggle={setCurrency}
        onResetDemo={handleResetDemo}
        isResetting={isResetting}
      />

      {/* Hero Section with Interactive Seat Headcount Estimator */}
      <TelecallingHero
        currency={currency}
        onOpenProposalModal={handleOpenProposalFromHero}
      />

      {/* Campaign Offerings Section */}
      <TelecallingServicesSection
        currency={currency}
        onSelectCampaign={handleSelectCampaign}
      />

      {/* Infrastructure, Compliance & Dialing Floor Roster */}
      <TelecallingTrustSection />

      {/* Footer */}
      <footer className="bg-slate-950 border-t border-slate-900 py-10 px-4 text-center text-xs text-slate-500">
        <p className="text-slate-400 font-medium">
          Vocalis BPO &amp; Outbound Telecalling Solutions • Manyata Tech Park, Nagavara, Bangalore 560045
        </p>
        <p className="mt-1">
          SOC-2 Type II Certified • ISO 27001 • Official Contact Center Demonstration by Johnson Softwares
        </p>
      </footer>

      {/* Interactive Proposal Modal */}
      {isModalOpen && (
        <CampaignProposalModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          initialData={modalInitialData}
          currency={currency}
        />
      )}
    </main>
  );
}
